/*** Scroll Handling ***/
(function handlePageScroll(window, document) {
	const html = document.documentElement;
	let previousScrollY = 0;

	function pageScroll() {
		const currentScrollY = window.scrollY;
		const scrollDifference = previousScrollY - currentScrollY;

		if (currentScrollY <= 0) {
			html.classList.remove("page-scrolling", "page-scrolling--up", "page-scrolling--down");
		} else {
			html.classList.add("page-scrolling");
			if (scrollDifference > 0) {
				html.classList.add("page-scrolling--up");
				html.classList.remove("page-scrolling--down");
			} else {
				html.classList.add("page-scrolling--down");
				html.classList.remove("page-scrolling--up");
			}
		}

		previousScrollY = currentScrollY;
	}

	pageScroll();

	window.addEventListener("scroll", () => {
		pageScroll();
	});

	document.addEventListener("DOMContentLoaded", () => {
		pageScroll();
	});
})(window, document);


/*** Custom SVG ***/
(function () {
    const iconMap = {
    'svg.icon.icon-search': `
        <svg class="icon icon-search" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
            <path d="M10.4319 5.96582C10.4318 4.78165 9.96152 3.64604 9.12431 2.80859C8.2868 1.97109 7.15052 1.50008 5.96611 1.5C5.08286 1.50001 4.21905 1.76222 3.48466 2.25293C2.75045 2.74363 2.17808 3.44096 1.84013 4.25684C1.50215 5.07281 1.41396 5.97068 1.58622 6.83691C1.75854 7.70318 2.18337 8.49947 2.8079 9.12402C3.43247 9.74859 4.22872 10.1734 5.09501 10.3457C5.96127 10.518 6.85909 10.4298 7.67509 10.0918C8.49098 9.75384 9.18829 9.18149 9.679 8.44727C10.1697 7.71286 10.4319 6.84909 10.4319 5.96582ZM11.9319 5.96582C11.9319 7.14566 11.5825 8.29924 10.927 9.28027C10.2715 10.2613 9.33938 11.026 8.24931 11.4775C7.15919 11.9291 5.95931 12.0476 4.80204 11.8174C3.64485 11.5872 2.58166 11.0189 1.74736 10.1846C0.913057 9.35025 0.344739 8.28711 0.114545 7.12988C-0.11565 5.97262 0.00284514 4.77274 0.454388 3.68262C0.905906 2.59266 1.67073 1.66135 2.65165 1.00586C3.63272 0.350332 4.78619 1.20658e-05 5.96611 0C7.54829 0.00010073 9.06608 0.628319 10.1849 1.74707C11.3036 2.86586 11.9318 4.38362 11.9319 5.96582Z" fill="currentColor"/>
            <path d="M9.32731 9.32701C9.6202 9.03411 10.095 9.03411 10.3879 9.32701L14.0304 12.9696C14.3233 13.2625 14.3233 13.7372 14.0304 14.0301C13.7375 14.323 13.2628 14.323 12.9699 14.0301L9.32731 10.3876C9.03441 10.0947 9.03441 9.6199 9.32731 9.32701Z" fill="currentColor"/>
        </svg>`,
    'svg.icon.icon-account': `
        <svg class="icon icon-account" xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
            <path d="M6.66667 0C7.55072 0 8.39857 0.33363 9.02369 0.927495C9.64881 1.52136 10 2.32681 10 3.16667C10 4.00652 9.64881 4.81197 9.02369 5.40584C8.39857 5.9997 7.55072 6.33333 6.66667 6.33333C5.78261 6.33333 4.93477 5.9997 4.30964 5.40584C3.68452 4.81197 3.33333 4.00652 3.33333 3.16667C3.33333 2.32681 3.68452 1.52136 4.30964 0.927495C4.93477 0.33363 5.78261 0 6.66667 0ZM6.66667 1.58333C6.22464 1.58333 5.80072 1.75015 5.48816 2.04708C5.1756 2.34401 5 2.74674 5 3.16667C5 3.58659 5.1756 3.98932 5.48816 4.28625C5.80072 4.58318 6.22464 4.75 6.66667 4.75C7.10869 4.75 7.53262 4.58318 7.84518 4.28625C8.15774 3.98932 8.33333 3.58659 8.33333 3.16667C8.33333 2.74674 8.15774 2.34401 7.84518 2.04708C7.53262 1.75015 7.10869 1.58333 6.66667 1.58333ZM6.66667 7.125C8.89167 7.125 13.3333 8.17792 13.3333 10.2917V12.6667H0V10.2917C0 8.17792 4.44167 7.125 6.66667 7.125ZM6.66667 8.62917C4.19167 8.62917 1.58333 9.785 1.58333 10.2917V11.1625H11.75V10.2917C11.75 9.785 9.14167 8.62917 6.66667 8.62917Z" fill="currentColor"/>
        </svg>`,
    'svg.icon.icon-bag': `
        <svg class="icon icon-bag" xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
            <path d="M0.59375 3.71094H3.11719V3.41406C3.11719 1.52891 4.64609 0 6.53125 0C8.41641 0 9.94531 1.52891 9.94531 3.41406V3.71094H12.4688C12.7972 3.71094 13.0625 3.97627 13.0625 4.30469V14.25C13.0625 14.5784 12.7972 14.8438 12.4688 14.8438H0.59375C0.265332 14.8438 0 14.5784 0 14.25V4.30469C0 3.97627 0.265332 3.71094 0.59375 3.71094ZM8.60938 3.41406C8.60938 2.26553 7.67979 1.33594 6.53125 1.33594C5.38271 1.33594 4.45312 2.26553 4.45312 3.41406V3.71094H8.60938V3.41406ZM1.33594 13.5078H11.7266V5.04688H9.94531V6.67969C9.94531 6.76133 9.87852 6.82812 9.79688 6.82812H8.75781C8.67617 6.82812 8.60938 6.76133 8.60938 6.67969V5.04688H4.45312V6.67969C4.45312 6.76133 4.38633 6.82812 4.30469 6.82812H3.26562C3.18398 6.82812 3.11719 6.76133 3.11719 6.67969V5.04688H1.33594V13.5078Z" fill="currentColor"/>
        </svg>`,
    'svg.icon.icon-close': `
        <svg class="icon icon-close" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M1.05375 13.3075L0 12.2538L5.6 6.65375L0 1.05375L1.05375 0L6.65375 5.6L12.2537 0L13.3075 1.05375L7.7075 6.65375L13.3075 12.2538L12.2537 13.3075L6.65375 7.7075L1.05375 13.3075Z" fill="currentColor"/>
        </svg>`,
    };

    Object.entries(iconMap).forEach(([sel, html]) => {
        document.querySelectorAll(sel).forEach((svg) => (svg.outerHTML = html));
    })();
});

/*** Custom Header ***/
(function () {
  function applyClass() {
    if (document.getElementById('header-transparent')) {
      document.body.classList.add('is-header-transparent');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyClass);
  } else {
    applyClass();
  }

  function updateHeights() {
		const announcementH = document.querySelector(".header-announcement-bar")?.offsetHeight || 0;
		const root = document.documentElement.style;

		root.setProperty("--page-announcement-height", `${announcementH}px`);
	}
	updateHeights();
	let resizeTimer;
	window.addEventListener("resize", () => {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(updateHeights, 100);
	});

})();